import script from "./RecursiveExpansionPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./RecursiveExpansionPanel.vue?vue&type=script&setup=true&lang=js"

import "./RecursiveExpansionPanel.vue?vue&type=style&index=0&id=328d4947&lang=css"

const __exports__ = script;

export default __exports__